import FintechAPICaller from '../../../utils/FintechAPICaller';
import { API_PATHS } from '../constants';
import { IScoreSummaryResponse } from '../types/api';

export interface ConsultationIndicatorsPayload {
  averageTicket: number;
  delinquencyRate: number;
  averageMonthlySales: number;
  averageDaysToCollect: number;
  usedCredit: number;
  latePayment: boolean;
  inactiveCustomer: boolean;
  increasingDelinquency: boolean;
  /** Total de parceiros ativos do cliente (TGFPAR) — base da faixa "Sem consulta". */
  totalPartners?: number;
  externalId?: string;
  name?: string;
}

export function buildIndicatorsPayload(summary: IScoreSummaryResponse): ConsultationIndicatorsPayload {
  const partner = summary.partners?.length ? summary.partners[summary.partners.length - 1] : undefined;

  return {
    averageTicket: summary.averageTicket ?? 0,
    delinquencyRate: summary.delinquenceyRate ?? 0,
    averageMonthlySales: summary.averageMonthlySales ?? 0,
    averageDaysToCollect: summary.averageDaysToCollect ?? 0,
    usedCredit: summary.usedCredit ?? 0,
    latePayment: summary.latePayment,
    inactiveCustomer: summary.inactiveCustomer,
    increasingDelinquency: summary.increasingDelinquency,
    totalPartners: summary.totalPartners,
    externalId: partner?.partnerCode != null ? String(partner.partnerCode) : undefined,
    name: partner?.partnerName,
  };
}

export async function saveConsultationIndicators(
  document: string,
  consultationId: string,
  payload: ConsultationIndicatorsPayload,
): Promise<void> {
  await FintechAPICaller.post({
    servicePath: API_PATHS.SAVE_CONSULTATION_INDICATORS_SNAPSHOT(document, consultationId),
    data: payload,
  });
}
